import { render } from "./categoryDetail.vue?vue&type=template&id=fadb31f4&ts=true"
import script from "./categoryDetail.vue?vue&type=script&lang=ts"
export * from "./categoryDetail.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__